// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nAASs","col":"styles_col__2jo4p"};